import { gql } from 'graphql-request';

import {
  CustomFieldBody,
  CustomFieldCheckedAt,
  CustomFieldCompanyID,
  CustomFieldID,
  CustomFieldLabel,
  CustomFieldLocation,
  CustomFieldOptions,
  CustomFieldOrder,
  CustomFieldUUID
} from '../customFieldsTypes';
import {
  CustomFieldValueDefaultAt,
  CustomFieldValueID,
  CustomFieldValueText
} from '../../customFieldValues/customFieldValuesTypes';

export interface FetchCacheCustomFieldsQueryResponse {
  body: CustomFieldBody;
  checkedAt: CustomFieldCheckedAt;
  companyId: CustomFieldCompanyID;
  customFieldValues: {
    defaultAt: CustomFieldValueDefaultAt;
    id: CustomFieldValueID;
    text: CustomFieldValueText;
  }[];
  id: CustomFieldID;
  label: CustomFieldLabel;
  location: CustomFieldLocation;
  options: CustomFieldOptions;
  order: CustomFieldOrder;
  uuid: CustomFieldUUID;
}

export const FETCH_CACHE_CUSTOM_FIELDS_QUERY = gql`
  query CacheCustomFields(
    $filters: CustomFieldsFilters
    $sort: [CustomFieldsSortEnum!]
    $limit: Int
    $offset: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    customFields(
      filters: $filters
      sort: $sort
      limit: $limit
      offset: $offset
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        body
        checkedAt
        companyId
        customFieldValues {
          defaultAt
          id
          text
        }
        id
        label
        location
        options
        order
        uuid
      }
      paginationInfo {
        currentPage
        firstPage
        lastPage
        limitValue
        nextPage
        outOfRange
        prevPage
        totalCount
        totalPages
      }
      sql
    }
  }
`;
